<div class="transcode-container  main-container">
	<h2><i class="fa fa-upload"></i>{{ 'UPLOAD' | translate }}</h2>
	<div class="imports">
		<mat-form-field appearance="fill" class="full-width">
			<mat-label>{{"SELECT_PRESET" | translate}}</mat-label>
			<mat-select [(ngModel)]="selectedProfile" name="selectedProfile" (ngModelChange)="settingsChanged()" #matSelect>
				<mat-option *ngFor="let profile of mediaProfiles" [value]="profile.name">
					{{ profile.name }}
					<i *ngIf="profile.label === 'Custom'" (click)="deleteProfile(profile)" class="button fa fa-trash"></i>
				</mat-option>
				<div class="mat-option create-preset" (click)="createPreset()">
					{{ 'CREATE_PRESET' | translate }} 
					<i class="fa-solid fa-arrow-right"></i>
				</div>
			</mat-select>
		</mat-form-field>

		<bb-collapsible [title]="'ADVANCED' | translate" togglePosition="before" theme="blue">
			<div class="collapsible">
				<bb-form-element [postLabel]="'TITLE_FROM_FILENAME' | translate" [helpMessage]="'HELP.TITLE_FROM_FILENAME' | translate" [hideLabel]="true">
					<bb-check [(ngModel)]="autoName" [name]="'autoName'" (ngModelChange)="settingsChanged()"></bb-check>
				</bb-form-element>
				<bb-form-element [hasPermission]="'publish'" [postLabel]="'AUTO_PUBLISH' | translate" [helpMessage]="'HELP.AUTO_PUBLISH' | translate" [hideLabel]="true">
					<bb-check [(ngModel)]="autoPublish" [name]="'autoPublish'" (ngModelChange)="settingsChanged()"></bb-check>
				</bb-form-element>
				<hr/>
				<div>
					<bb-embargo [(ngModel)]="embargo"></bb-embargo>
				</div>
			</div>
		</bb-collapsible>

		<div class="upload" override>
			<bb-upload [createNewMediaclip]="true" [large]="true" [autoName]="autoName" [autoPublish]="autoPublish" [embargo]="embargo" [recommendationsTable]="true" [selectedProfile]="selectedProfile"></bb-upload>
		</div>

		<hr />

		<div *ngIf="!disableImport" class="import-container">
			<bb-import [autoPublish]="autoPublish" [transcodingProfile]="selectedProfile"></bb-import>
			<p [innerHTML]="'SUPPORT_SITE_IMPORT_DISCLAIMER' | translate"></p>
		</div>
	</div>
</div>

<ng-template #createPresetTemplate>
	<bb-create-preset (modalClose)="closeModal($event)"></bb-create-preset>
</ng-template>
